import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';

export const Wrapper = styled.div`
  padding: ${sizes.small};
  background: ${colors.white};
  border: 1px solid ${colors.gray3};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  & > div {
    padding-bottom: 0;
  }
`;
